<div class="feature-flag-container">
  <div class="feature-flag-header">
    <div class="flex flex-row justify-between items-center mb-24">
      <div>
        <h1 class="mat-headline-4 fw-600 m-0">{{ 'FEATURE_FLAG.TITLE' | transloco }}</h1>
        <p class="mat-body-2 neutral-3-fg mt-8 mb-0">{{ 'FEATURE_FLAG.SUBTITLE' | transloco }}</p>
      </div>
      <button class="refresh-btn" (click)="refresh()" [disabled]="isLoading">
        <mat-icon svgIcon="refresh" [ngClass]="{ 'animate-spin': isLoading }"></mat-icon>
        {{ 'BUTTONS.REFRESH' | transloco }}
      </button>
    </div>

    @if (isInstanceMode && currentInstance) {
      <div class="tenant-info mb-24">
        <span class="mat-body-2 fw-500">{{ 'FEATURE_FLAG.CURRENT_ENVIRONMENT' | transloco }}</span>
        <span class="mat-body-2 fw-600 ml-8">{{ currentInstance }}</span>
      </div>
    } @else if (!isInstanceMode && currentTenant) {
      <div class="tenant-info mb-24">
        <span class="mat-body-2 fw-500">{{ 'FEATURE_FLAG.CURRENT_TENANT' | transloco }}</span>
        <span class="mat-body-2 fw-600 ml-8">{{ currentTenant }}</span>
      </div>
    }

    @if (error) {
      <div class="error-alert mb-24">
        <mat-icon svgIcon="error" class="mr-8"></mat-icon>
        <span>{{ error }}</span>
      </div>
    }
  </div>

  @if (isLoading) {
    <div class="loading-container">
      <mat-spinner diameter="40" color="primary"></mat-spinner>
      <p class="mt-16 mat-body-2">{{ 'FEATURE_FLAG.LOADING' | transloco }}</p>
    </div>
  } @else if (featureFlags.length === 0) {
    <div class="empty-state">
      <mat-icon svgIcon="info" class="empty-icon"></mat-icon>
      <p class="mat-body-2 mt-16">{{ 'FEATURE_FLAG.NO_FLAGS_FOUND' | transloco }}</p>
    </div>
  } @else {
    <div class="feature-flags-table">
      <table>
        <thead>
          <tr>
            <th class="id-col">{{ 'FEATURE_FLAG.TABLE_ID' | transloco }}</th>
            <th class="status-col">{{ 'FEATURE_FLAG.TABLE_STATUS' | transloco }}</th>
          </tr>
        </thead>
        <tbody>
          @for (flag of featureFlags; track flag.id) {
            <tr [ngClass]="{ 'enabled-row': isFeatureFlagEnabled(flag.id), 'disabled-row': !isFeatureFlagEnabled(flag.id) }">
              <td class="id-col">
                <code class="flag-id">{{ flag.id }}</code>
              </td>
              <td class="status-col">
                <mat-slide-toggle [checked]="isFeatureFlagEnabled(flag.id)" class="mr-8 read-only" disabled></mat-slide-toggle>
                <span class="toggle-label">{{ isFeatureFlagEnabled(flag.id) ? ('FEATURE_FLAG.ENABLED' | transloco) : ('FEATURE_FLAG.DISABLED' | transloco) }}</span>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</div>
